import AccountService from "../../Services/AccountService";
import LabOrderService from "../../Services/LabOrderService";
import PharmacyService from "../../Services/PharmacyService";

export const FETCH_PHARMACYORDERS_REQUEST = "FETCH_PHARMACYORDERS_REQUEST";
export const FETCH_PHARMACYORDERS_SUCCESS = "FETCH_PHARMACYORDERS_SUCCESS";
export const FETCH_PHARMACYORDERS_FAILURE = "FETCH_PHARMACYORDERS_FAILURE";

export const FETCH_LABORDERS_REQUEST = "FETCH_LABORDERS_REQUEST";
export const FETCH_LABORDERS_SUCCESS = "FETCH_LABORDERS_SUCCESS";
export const FETCH_LABORDERS_FAILURE = "FETCH_LABORDERS_FAILURE";

export const FETCH_INCLINICORDERS_REQUEST = "FETCH_INCLINICORDERS_REQUEST";
export const FETCH_INCLINICORDERS_SUCCESS = "FETCH_INCLINICORDERS_SUCCESS";
export const FETCH_INCLINICORDERS_FAILURE = "FETCH_INCLINICORDERS_FAILURE";

export const FETCH_OPORDERS_REQUEST = "FETCH_OPORDERS_REQUEST";
export const FETCH_OPORDERS_SUCCESS = "FETCH_OPORDERS_SUCCESS";
export const FETCH_OPORDERS_FAILURE = "FETCH_OPORDERS_FAILURE";

export const FETCH_ORDER_REPORTS_REQUEST = "FETCH_ORDER_REPORTS_REQUEST";
export const FETCH_ORDER_REPORTS_SUCCESS = "FETCH_ORDER_REPORTS_SUCCESS";
export const FETCH_ORDER_REPORTS_FAILURE = "FETCH_ORDER_REPORTS_FAILURE";

export const FETCH_ORDER_REPORTS_COUNT_REQUEST = "FETCH_ORDER_REPORTS_COUNT_REQUEST";
export const FETCH_ORDER_REPORTS_COUNT_SUCCESS = "FETCH_ORDER_REPORTS_COUNT_SUCCESS";
export const FETCH_ORDER_REPORTS_COUNT_FAILURE = "FETCH_ORDER_REPORTS_COUNT_FAILURE";


export const fetchPharmacyOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_PHARMACYORDERS_REQUEST });
    try {
        const response = await PharmacyService.getMedicineOrdersList(payload);
        dispatch({ type: FETCH_PHARMACYORDERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_PHARMACYORDERS_FAILURE, payload: error.message });
    }
}

export const fetchLabOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_LABORDERS_REQUEST });
    try {
        const response = await LabOrderService.getLabOrdersList(payload);
        dispatch({ type: FETCH_LABORDERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_LABORDERS_FAILURE, payload: error.message });
    }
}

export const fetchInclinicOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_INCLINICORDERS_REQUEST });
    try {
        const response = await LabOrderService.LabReportUploadGet(payload);
        dispatch({ type: FETCH_INCLINICORDERS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_INCLINICORDERS_FAILURE, payload: error.message });
    }
}

export const fetchOpOrders = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_OPORDERS_REQUEST });
    try {
        const response = await LabOrderService.OpOrdersList(payload);
        dispatch({ type: FETCH_OPORDERS_SUCCESS, payload: response.data.data });
    }
    catch (error) {
        dispatch({ type: FETCH_OPORDERS_FAILURE, payload: error.message });
    }
}

export const fetchOrderReports = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_ORDER_REPORTS_REQUEST });
    try {
        const response = await  AccountService.getOrderReport(payload);
        dispatch({ type: FETCH_ORDER_REPORTS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_ORDER_REPORTS_FAILURE, payload: error.message });
    }
}

export const fetchOrderReportsCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_ORDER_REPORTS_COUNT_REQUEST });
    try {
        const response = await  AccountService.getTotalOrderReportsCount(payload);
        dispatch({ type: FETCH_ORDER_REPORTS_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_ORDER_REPORTS_COUNT_FAILURE, payload: error.message });
    }
}

